import { IFaceRecognitionEventSimpleProps } from '../FaceRecognitionEventService/types';
import { ICustomerRecognitionSimpleProps } from '../../Recognition/Customer/types';

export interface ICustomerRecognitionEventSimpleProps
  extends IFaceRecognitionEventSimpleProps {
  customerRecognition: ICustomerRecognitionSimpleProps;
}

export interface ICustomerEvetFilterParams {
  search?: string;
}

export enum CustomerRecognitionEventViewType {
  QUEUE = 0,
  LIST = 1,
}
